import { Commodity } from '../types/all';

import { DeliveryPoint } from './delivery-point.model';

/**
 * Model for API BaseCustomerSite Model
 */
export class Site {
  /**
   * Site unique  id
   */
  id: number;

  /**
   * Site name according to different populations of Users
   */
  labels: {
    internal: string;
    external: string;
  };

  /**
   * Site address
   */
  address: string;

  /**
   * Site country code
   */
  country: string;

  /**
   * List of metering points located in site
   */
  points: DeliveryPoint[];

  contractIds: number[];

  /**
   * Account Id of the site
   */
  accountId: number;

  constructor(attributes: Partial<Site> = {}) {
    Object.assign(this, attributes);
  }

  toString() {
    return this.labels?.external || this.id?.toString();
  }

  containsDeliveryPoint(deliveryPoint: DeliveryPoint): boolean {
    const index = this.points.findIndex((dp: DeliveryPoint) => dp.poorlyEqualTo(deliveryPoint));

    return -1 !== index;
  }

  /**
   * Returns the delivery points of a selected commodity for this Site.
   */
  getPointsByCommodity(commodity?: Commodity): DeliveryPoint[] {
    let points = this.points;

    if (commodity) {
      points = points.filter((point: DeliveryPoint) => point.commodity === commodity);
    }

    return points;
  }

  get gasPoints() {
    return this.getPointsByCommodity(Commodity.gas);
  }

  get powerPoints() {
    return this.getPointsByCommodity(Commodity.power);
  }

  isActive(): boolean {
    return !this.points || this.points.some((point: DeliveryPoint) => point.isActive());
  }

  isInDelivery(): boolean {
    return !this.points || this.points.some((point: DeliveryPoint) => point.inDelivery);
  }

  label(inactiveText: string) {
    return (this.labels ? this.labels.external : '') + (this.isActive() ? '' : ' (' + inactiveText + ')');
  }
}
